import { render } from "./EventPickerDialog.vue?vue&type=template&id=90857a08"
import script from "./EventPickerDialog.vue?vue&type=script&lang=ts"
export * from "./EventPickerDialog.vue?vue&type=script&lang=ts"

import "./EventPickerDialog.vue?vue&type=style&index=0&id=90857a08&lang=css"
script.render = render

export default script